import React, { ReactNode } from 'react';

import moment from 'moment';

import { LinearProgress } from '@material-ui/core';
import { Box } from '@mui/material';

import { FaRoute } from 'react-icons/fa';

import {
    useTaskId,
    useTaskPaneLoading,
} from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';

import TranslationHelper from '../../../../../../../helpers/TranslationHelper';
import { handleQueryData } from '../../../../../../../helpers/replacers';

import PaneHeader from '../../../../../../../components/PaneHeader/PaneHeader';
import IconButtonWithTooltip from '../../../../../../../components/IconButtonWithTooltip/IconButtonWithTooltip';
import { IServiceTask } from 'src/app/models/customerService';
import TaskHeader from '../../../../../../../features/TaskForm/components/TaskHeader';
import ReportPreview from '../../../../../../../components/report/ReportPreview';
import { ITask } from '../../../../../../../state/types';
import { useUserSettings } from '../../../../../../../state/user/index.hooks';

interface IOwnProps {
    task: IServiceTask | null;
    taskReport: ITask | null;
    handleClose: () => void;
    titleComponent?: ReactNode;
}

const TaskPreview = ({
    task,
    taskReport,
    handleClose,
    titleComponent,
}: IOwnProps) => {
    const taskId = useTaskId();
    const paneLoading = useTaskPaneLoading();
    const taskDetails = taskReport?._meta.header.task || null;
    const taskIcon = taskReport?._meta.header.icon || null;
    const taskReports = taskReport?.reports || null;
    const userSettings = useUserSettings();

    const handleShowEvent = () => {
        const data = {
            action: {
                type: 'showEventFromTask',
                params: {
                    id: taskId,
                },
            },
        };
        const query = handleQueryData(data, false);
        window.open(`/discovery?action=${query}`, '_blank');
    };

    const renderRightCustomControls = () => {
        return task &&
            moment(task.plannedOn).isSameOrBefore(moment(), 'days') ? (
            <IconButtonWithTooltip
                title={TranslationHelper.translate('Show event')}
                onClick={handleShowEvent}
            >
                <FaRoute />
            </IconButtonWithTooltip>
        ) : (
            <></>
        );
    };
    const renderPlannedOn = () => {
        const plannedOn = task?.plannedOn;
        return plannedOn ? (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {`(${moment(plannedOn).format(userSettings.shortDateFormat)})`}
            </Box>
        ) : (
            <></>
        );
    };
    return (
        <div>
            <PaneHeader
                onCloseClick={handleClose}
                title={TranslationHelper.translate('Task')}
                titleComponent={titleComponent}
                renderRightCustomControls={renderRightCustomControls}
                renderLeftCustomControls={renderPlannedOn}
            />
            {!task || paneLoading ? (
                <LinearProgress />
            ) : (
                <>
                    <TaskHeader taskDetails={taskDetails} taskIcon={taskIcon} />
                    <ReportPreview reports={taskReports} />
                </>
            )}
        </div>
    );
};

export default TaskPreview;
